import React from 'react';
import { userPictureUrl } from '@/lib/media';

export function Navbar({ user, activeView, onSearch, searchQuery, onMobileSearch, onNotifications, notificationCount=0, onUpload, onOpenProfile, onOpenSettings, onLogout, onToggleSidebar, showUserMenu, setShowUserMenu, getMediaUrl }) {
  const shopMode=activeView==='shop';
  return (
    <div 
      className="sticky top-0 z-50 flex items-center gap-2 sm:gap-4 px-3 sm:px-6 py-3 border-b"
      style={{
        background: 'var(--panel-tint)',
        backdropFilter: 'blur(20px)',
        borderBottomColor: 'var(--glass-border)'
      }}
    >
      <button
        onClick={onToggleSidebar}
        data-testid="toggle-sidebar-btn"
        className="p-2 rounded-lg hover:bg-white/5 transition-colors text-white/80"
      >
        <i className={`ti ${shopMode?'ti-arrow-left':'ti-menu-2'} text-xl`}></i>
      </button>

      <div className="flex items-center gap-2.5 mobile-brand">
        <img src="/blop.png?v=5" alt="BlopBoru" className="h-8 w-8 object-contain rounded-md" />
        <div className="hidden sm:block text-xl font-extrabold tracking-tight">
          {shopMode?<><span style={{color:'#d9b778'}}>Lojinha</span> BlopBoru</>:<>Blop<span style={{color:'var(--accent)'}}>Boru.</span></>}
        </div>
      </div>

      <div 
        className="desktop-search flex-1 flex items-center gap-2 rounded-xl px-3 sm:px-4 transition-colors"
        style={{
          background: 'var(--glass)',
          border: '1px solid var(--glass-border)',
        }}
      >
        <i className="ti ti-search text-white/40"></i>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Buscar artes, perfis ou tags..."
          data-testid="search-input"
          className="flex-1 bg-transparent border-none outline-none text-white text-sm py-2.5 placeholder:text-white/30"
        />
      </div>

      <button className="mobile-top-search" onClick={onMobileSearch} aria-label="Pesquisar obras e pessoas">
        <i className="ti ti-search"></i>
      </button>

      <button className="notification-button" onClick={onNotifications} aria-label="Abrir notificações">
        <i className="ti ti-bell"></i>{notificationCount>0&&<span>{notificationCount>99?'99+':notificationCount}</span>}
      </button>

      <button
        onClick={onUpload}
        data-testid="upload-btn"
        className="desktop-upload hidden sm:flex items-center gap-1.5 px-4 py-2.5 rounded-lg text-sm font-medium text-white/80 hover:text-white transition-colors"
        style={{
          background: 'var(--glass)',
          border: '1px solid var(--glass-border)'
        }}
      >
        <i className="ti ti-upload"></i>
        Publicar
      </button>

      <div className="desktop-user relative">
        <button
          onClick={() => setShowUserMenu(!showUserMenu)}
          data-testid="user-avatar-btn"
          className="w-10 h-10 rounded-full flex items-center justify-center overflow-hidden transition-all"
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid var(--glass-border)'
          }}
        >
          {user?.picture ? (
            <img src={userPictureUrl(user.picture, getMediaUrl)} alt={user.name} className="w-full h-full object-cover" />
          ) : (
            <i className="ti ti-user text-white/60 text-lg"></i>
          )}
        </button>

        {showUserMenu && (
          <div 
            className="absolute right-0 top-12 min-w-[210px] rounded-xl overflow-hidden animate-fade-up z-50"
            style={{
              background: 'var(--card-bg)',
              border: '1px solid var(--glass-border)',
              boxShadow: '0 10px 25px rgba(0,0,0,0.5)'
            }}
          >
            <div className="flex items-center justify-between p-3 border-b border-white/5">
              <div className="flex flex-col gap-0.5">
                <span className="text-sm font-semibold text-white">{user?.name}</span>
                <span className="text-xs text-white/40">@{user?.handle}</span>
              </div>
              <button
                onClick={() => { setShowUserMenu(false); onOpenSettings(); }}
                data-testid="dropdown-settings-btn"
                className="w-8 h-8 rounded-lg flex items-center justify-center transition-all hover:rotate-45"
                style={{
                  background: 'var(--glass)',
                  border: '1px solid var(--glass-border)',
                }}
              >
                <i className="ti ti-settings text-white/70"></i>
              </button>
            </div>
            <button
              onClick={() => { setShowUserMenu(false); onOpenProfile(); }}
              data-testid="dropdown-profile-btn"
              className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors"
            >
              <i className="ti ti-user text-base"></i>
              Meu Perfil
            </button>
            <button
              onClick={() => { setShowUserMenu(false); onLogout(); }}
              data-testid="dropdown-logout-btn"
              className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-red-400 hover:bg-white/5 transition-colors border-t border-white/5"
            >
              <i className="ti ti-logout text-base"></i>
              Sair
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
